import {
  AUTHOR,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function author(state = initialState, action) {
  switch (action.type) {
    case AUTHOR.handlers.fetch:
    case AUTHOR.handlers.update:
    case AUTHOR.handlers.import:
    case AUTHOR.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case AUTHOR.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
